import axios from 'axios'
import URLS from '@/constants/url'

const configure = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
  },
  baseURL: URLS.api
}

const api = axios.create(configure)

export default api
